module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_c('strong', [_vm._v("CHAPTER 1")])]), _c('br'), _c('em', [_vm._v("Geological Enterprise")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteb"
  }, [_vm._v("Coal is power, it is the foundation of manufacturing industry, the greatest source of national wealth; and administers largely to the comforts of man. . . . It hurls the train along the rail-road, the boat across the mighty deep; it lights the city traveller along his midnight way, and warms the shivering peasant after his daily toil."), _c('br'), _vm._v("—Abraham Gesner, "), _c('em', [_vm._v("Remarks on the Geology and Mineralogy of Nova Scotia")]), _vm._v(" (1836)")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVA")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("COTIA MIGHT NOT SEEM")]), _vm._v(" the obvious place to begin a history of American coal, but it is a natural one. Since at least the eighteenth century, observers had commented on the splendid exposures of coal along its coasts, especially at the Joggins on Chignecto Bay, an arm of the Bay of Fundy."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Beginning in the 1830s, Nova Scotia was the largest producer of coal in British North America and a major exporter to the United States. To seaboard cities like Boston and New York, Nova Scotia’s coal was closer, easier to transport, and hence better priced than Pennsylvania’s. To American and British geologists, Nova Scotia’s coasts were among the best sites in the world to study the age and origin of coal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The geology of Nova Scotia, however, was much like its coal, something to be possessed and shipped around the North Atlantic as well as to be explored and explained. When the American geologist-chemist Charles Jackson began to study the province in the late 1820s, he started a contest over who would create and control the scientific knowledge of Nova Scotia. In that struggle, Jackson’s principal adversary would be Abraham Gesner, a country surgeon turned geologist; but others, like the British gentlemanly geologist Charles Lyell, would soon join in. Which one was to be the expert on Nova Scotia?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The answer depended on what, exactly, a geologist had to offer, and to whom. For Gesner, geology was the necessary prerequisite to finding the all-powerful coal and sending it on its civilizing mission. Such scientific optimism was welcomed "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("in Nova Scotia as well as in neighboring New Brunswick, where in 1838 Gesner was appointed the provincial geologist, the first such position in any British colony."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The context and consequences of that unprecedented initiative warrant historical examination; for Gesner found a great coal field. “It exceeds in its dimensions any found in Great Britain,” he declared, “and is one of the largest ever discovered upon the globe.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Gesner’s discovery caused quite a stir in scientific and commercial circles; but it also raised poignant problems about how to reconcile geological information with mining investments and about the proper role a surveyor should and could play in developing the coal he finds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As it turned out, Gesner’s role was not what some in New Brunswick anticipated, and so, by the early 1840s, he, like many former surveyors, was in search of ways to make a living doing science. By accompanying Gesner on his various employments, historians can gain some new insights into scientific entrepreneurship as well as the culture of coal in early nineteenth-century America.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('em', [_vm._v("Plagiarism, Patronage, and Expertise")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("Abraham Gesner was born in Cornwallis, Nova Scotia, “the garden of Acadia,” on 2 May 1797."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n4a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" One of twelve children of Henry Gesner and Sarah Pineo, he received little formal education, nothing more than “the ordinary instruction of the grammar schools of the day,” although he was “a great reader.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n5a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" As a young man, Gesner experimented with a number of moneymaking schemes, including a partnership in an ill-fated venture to trade Nova Scotia horses for West Indies rum. When that business ended in shipwreck, Gesner settled down to farming, and in 1822 he married Harriet Webster, the daughter of Isaac Webster, a prominent physician from Kentville. Gesner, however, proved as adept at farming as he was at horse trading. Attempts at scientific agriculture put him in debt, and soon he was under house arrest, much to the chagrin of the wealthy Websters, who were forced to bail out their son-in-law. In return, Gesner agreed to give up farming, and in 1825, with his father-in-law’s backing, he traveled to London to study surgery at Guy’s Hospital and St. Bartholomew’s Hospital. There Gesner received his only formal instruction in science, most likely chemistry and "), _c('em', [_vm._v("materia medica.")]), _vm._v(" Within a year, though, he had returned home upon learning of the death of his second son."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n6a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" He chose to settle in Parrsboro, on the north shore of the Minas Basin, across the bay from his in-laws, where he served as surgeon to the local military garrison. Gesner, however, showed more concern for the area’s natural history than for the soldiers. In the tradition of a country physician, he collected minerals, rocks, and fossils on his rambles."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n7a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" As the local expert, he was probably not surprised when two Bostonians dropped by.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charles Thomas Jackson (1805–1880) and Francis Alger (1807–1863) were “tourists” in search of rare and beautiful curiosities of natural history. Back in "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("the summer of 1826, they had made a reconnaissance of Nova Scotia and the following year had coasted along the peninsula from Brier Island to the Minas Basin and then around Cape Chignecto and into Cumberland Bay. An account of their travels appeared in 1828 as “A Description of the Mineralogy and Geology of a Part of Nova Scotia.” By the summer of 1829, when they visited Gesner, Jackson and Alger were planning an expanded edition."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n8a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their object was a mineral geography, “to describe only those [minerals] which are peculiar to the place, or which possess singular beauty, or present remarkable phenomena.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n9a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Jackson and Alger found many valuable kinds, including amethyst, jasper, stilbite, and zeolite, and they noted where to pick up samples along the shore. Bypassing locations with “no objects of natural history worthy of description,”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" they instead focused on areas that promised prized specimens, such as the trap rocks of the North Mountains, a range running along the Bay of Fundy and skirting the southern shore of the Minas Basin."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n11a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" In Jackson and Alger’s view, the rocks were not as interesting as the minerals they contained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The distinction between rocks and minerals went back at least to the mid-eighteenth century. Minerals were defined as natural kinds, individual species best exemplified by crystals, although not all minerals formed crystals. Rocks were mixtures of minerals. Granite, for instance, was composed primarily of quartz, feldspar, and mica crystals. Moreover, rocks occurred as large, independent masses with a thickness and geographical extension. According to Abraham Gottlob Werner (1750–1817), the famed professor of mineralogy at the Königliche Sächsische Bergakademie at Freiberg, all rocks on the Earth’s surface were of aqueous origin. They had precipitated out of a primal ocean once covering the entire globe. Consequently, rocks were layered one on top of the other in an orderly and sequential stack. Trap, a rock that Jackson and Alger thought was very contentious, was at the top of Werner’s stack."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In contrast to the Wernerian or “Neptunist” theory, the Scottish philosopher James Hutton (1726–1797) had proposed an igneous origin for rocks. Rather than precipitate down, rocks had risen up from the seabed where they had been consolidated by heat. By this “Vulcanist” theory, trap was the product of heat and, according to some of Hutton’s followers, the lava of ancient volcanoes."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n13a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Jackson and Alger favored the Vulcanist theory. They believed the Nova Scotia trap had been ejected suddenly and violently from the “unfathomable depths of the Bay of Fundy.” In their opinion, the bay was a huge volcanic crater."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n14a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In treating Nova Scotia’s other rocks, Jackson and Alger relied on Werner. Besides his Neptunist theory, Werner had proposed a classification system for rocks toward the end of the eighteenth century. In brief, Werner’s system was based on the idea of a "), _c('em', [_vm._v("formation")]), _vm._v("—a group of rocks that shared specific characters."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n15a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" In the early nineteenth century, formations were usually characterized by "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("their composition or lithology (the rock type), which was how Jackson and Alger identified them. Thus, for example, the formation Granite (capital G) consisted entirely of the rock granite (little g). Jackson and Alger identified two other similar formations in Nova Scotia, Quartz Rock and Clay Slate, each composed of only one rock, namely, quartz rock and clay slate. Identifying formations composed of only one rock type was relatively straightforward compared to identifying stratified formations composed of several different rock layers or strata. Such was the case with Jackson and Alger’s fourth formation. The Red Sandstone formation of Nova Scotia contained layers of shale, red sandstone, and conglomerate. Red sandstone was the predominant one, meaning the thickest and the one usually found on the surface. Accordingly, it was chosen for the name."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n16a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After identifying and naming some thirty rock formations, Werner had arranged them in chronological order, from oldest to youngest. The Primary or Primitive class comprised the oldest formations, the ones composed of a single rock type. Werner thought they were the first to precipitate out of the universal ocean and hence were to be found on mountaintops. As the universal ocean subsided, the next class of formations, the Transition, was deposited on the flanks of the Primary mountains. The Transition class was so named because it represented an intermediate position between the Primary and the Secondary classes. Secondary formations resulted from the deposition of sediments (bits and pieces worn away from Primary and Transition rocks). They contained layers of sedimentary rocks such as sandstone, shale, and conglomerate. The Secondary also contained limestone (a precipitate), although it required keen judgment to distinguish Primary, Transition, and Secondary limestones. Werner had characterized Secondary formations by their flat-lying position (for which he had originally named the class Floetz) and by their fossils, which were becoming increasingly important by the early nineteenth century. In practice, fossils distinguished the three classes of rocks: Primary formations contained none, Transition a few, and Secondary the most.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Using Werner’s system, Jackson and Alger outlined the geological structure of Nova Scotia (see "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01tab01"
    }
  }, [_vm._v("table 1.1")]), _vm._v("). The South Mountains were composed of Granite, the only Primitive formation on the peninsula. Overlying the Granite and tilted at a sharp angle of 50–60 degrees lay the Clay Slate formation, which belonged to the Transition because it contained a few fossils and some iron ore deposits. (Metals were considered another characteristic of Transition formations.) Around Halifax, Jackson and Alger mapped the Quartz Rock formation, which they also attributed to the Transition. Above this and in the Secondary class, they placed the Red Sandstone formation, which dipped at a slight 10–30 degrees and contained many fossils along with seams of coal and gypsum. Jackson and Alger thought the gypsum was of “practical worth,” but they regarded "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("the coal as very soft and friable, “a fault which greatly injures it for the market.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n17a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Lastly, at the very top, they placed the Trap of the North Mountains.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch01tab01"
    }
  }), _c('strong', [_vm._v("Table 1.1. Charles Jackson and Francis Alger’s Formations of Nova Scotia (1832) (Oldest to Youngest)")])]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "2",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Primitive Class")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Granite")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transition Class")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Quartz Rock")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Clay Slate")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Secondary Class")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Red Sandstone")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Trap")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Overall, Jackson and Alger described a simple and remarkably regular structure, one that could not “fail to excite the admiration of every geologist.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n18a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Indeed, their survey, one of the first to be undertaken in North America, was well received and widely read."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n19a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" The New York State geologist Ebenezer Emmons (1799–1863), for one, felt a “strong desire” to visit “the same interesting region,” and in the summer of 1836, he led a group of students from Williams College on an expedition. They, too, visited Gesner, who was also very excited having just published his own "), _c('em', [_vm._v("Remarks on the Geology and Mineralogy of Nova Scotia")]), _vm._v(" (1836)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n20a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner had no doubt been impressed by Jackson and Alger’s book, but they had not mentioned him in it, probably because they regarded Gesner as a mere amateur, someone with useful information but without scientific or cultural standing beyond Parrsboro. Gesner might well have been spurred to write his own book because of the slight, but he had also wanted to publish his observations for “the love of science” and “the gratification of curiosity.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n21a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" In the event, Gesner’s book sparked a heated dispute with Jackson, the first of many, over priority, patronage, and the proper behavior of men of science.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner’s title was nearly identical to Jackson and Alger’s, but the extent to which he copied their work was (and is) a matter of debate."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n22a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Gesner admitted that he had “received some information” from the Americans, just as they had received some information from him, but Gesner also relied on many other sources."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n23"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n23a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" More important than the details was Gesner’s design. In putting geology first in the title, Gesner signaled that mineralogy was decidedly inferior. He restricted minerals mostly to his section on the Trap and kept their descriptions short."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n24"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n24a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" In contrast to Jackson and Alger, Gesner thought gems were of little practical value. They would never “afford an article very important to commerce, "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("or make up the source of an abundant revenue” for Nova Scotia."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n25"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n25a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Economic resources, not ornamental curiosities, were Gesner’s main concern.")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('a', {
    attrs: {
      "id": "fig1"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcapb"
  }, [_vm._v("Abraham Gesner’s geological map of Nova Scotia (1846). Between his 1836 survey and the publication of this map, Gesner changed the names of his four major districts: Primary to Igneous; Clay Slate to Metamorphic & Silurian; Red Sandstone to Old Red & Gypsiferous; and Coal. The Trap district was deleted "), _c('em', [_vm._v("Source:")]), _vm._v(" Abraham Gesner, “A Geological Map of Nova Scotia, with accompanying memoir,” "), _c('em', [_vm._v("Proceedings of the Geological Society of London, 4")]), _vm._v(" (1846):186–190, facing page 186.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another reason for Gesner’s emphasis on geology was the way he conducted his survey. Jackson and Alger had sailed along the shore gathering minerals and studying their enclosing rocks as “viewed from the sea.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n26"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n26a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" They wrote as scientific tour guides for “traveller[s] proceeding from the United States to Halifax.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n27"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n27a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Gesner surveyed on the ground, along the roads, by foot, on horse, or in a gig. He explored many areas ignored by or inaccessible to Jackson and Alger."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n28"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n28a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" This was no easy task because most of the province, Gesner observed, was “covered in dense forests, and trackless mountains, where the moose and carriboo still enjoy quiet repose from the yell of the Indian, or the sound of the woodsman’s axe.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n29"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n29a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Native Americans, moose, and “lazy” bears popped up a lot in his book. The colorful details reminded readers of how vastly different the environment of “new countries” was from that of “old” Britain, where geology, although likewise pursued in the field, was less taxing and dangerous."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n30"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n30a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" In Nova Scotia, maps were nearly unknown; even measuring “the distances from one place to another” was frequently impossible."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n31"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n31a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Despite such hardships, Gesner succeeded in exploring most of the peninsula.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner divided Nova Scotia into four major “districts”—Primary, Clay Slate, Red Sandstone, and Trap. These corresponded to geographical regions, parts of the province where such rocks were exposed. Although Gesner’s districts recalled Jackson and Alger’s formations, the similarity disguised a confusing classification system. “District” sometimes meant “class” and sometimes “formation.” Gesner was inconsistent, and nowhere in his book did he step outside the thicket of details to give a clear overview of Nova Scotia’s rocks (see "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01tab02"
    }
  }, [_vm._v("table 1.2")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Basically, Gesner wrote a geological travelogue—his trip from township to township and the rocks he saw on the way. Around Halifax, for instance, he found Granite, which he classed as Primary. He did not find Clay Slate, as Jackson and Alger had. In fact, Gesner found no Transition formations and rejected the term "), _c('em', [_vm._v("transition,")]), _vm._v(" so called “by older Geologists.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n32"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n32a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" (To be fair, Jackson and Alger had also hesitated about using the term.)"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n33"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n33a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" When dismissing the Transition, Gesner deferred to Charles Lyell (1797–1875), who, in his "), _c('em', [_vm._v("Principles of Geology")]), _vm._v(" (1830–1833), had placed "), _c('em', [_vm._v("all")]), _vm._v(" formations above and younger than the Primary (i.e., ones with fossils or some signs of stratification) within the Secondary."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n34"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n34a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Yet despite this expressed rejection, Gesner repeatedly used the term “transition” to describe the four rocks (Clay Slate, Argillite, Greywacke, and Quartz Rock) he found in his Clay Slate district. In effect, Gesner undermined Lyell’s theoretical point that there was no transitional period between the Primary and Secondary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inconsistency and imprecision were also apparent in Gesner’s discussion of the Red Sandstone district, which contained "), _c('em', [_vm._v("two")]), _vm._v(" red sandstones, Old and New, "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("but often Gesner did not specify which one. In certain locations, such as Horton Bluff at the mouth of the Windsor River, he identified New Red Sandstone by its characteristic salt springs and gypsum beds."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n35"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n35a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Elsewhere he left the reader to wonder whether the all-important coal was above or below his unspecified red sandstone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch01tab02"
    }
  }), _c('strong', [_vm._v("Table 1.2. Abraham Gesner’s Geological Divisions of Nova Scotia (1836) (Oldest to Youngest)")])]), _vm._v(" "), _c('table', {
    staticClass: "table1",
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "2",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Primary District")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Granite")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Gneiss")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mica Slate")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clay Slate District")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Clay Slate")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Argillite")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Greywacke")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Quartz Rock")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Red Sandstone District")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Red Sandstone")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Coal")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "indent"
  }, [_vm._v("New Red Sandstone")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Trap District")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coal was the key to Gesner’s scientific perspective on Nova Scotia. He devoted nearly a quarter of his book to a discussion of its geology, its fossil plants, and theories of its origin, but practically all of this information came from English sources, primarily William Conybeare and William Phillips’s "), _c('em', [_vm._v("Outlines of the Geology of England and Wales")]), _vm._v(" (1822). Gesner’s contributions amounted to detailed descriptions of the coal fields at Pictou and the Joggins. Pictou was the larger. Ten seams, from one to three yards thick, were being mined and the coal was being exported. At the Joggins, Gesner counted eight seams, from half a foot to three feet thick, perfectly exposed from the cliff top to the beach, but none were being mined. “The strata are extremely regular, parallel and equal,” Gesner observed, “affording a section of a coal basin, not surpassed by any in the world.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n36"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n36a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" This might have been taken for hyperbole were it not for the numerous fossils, especially the upright trees, some as tall as forty feet and piercing several rock layers. Gesner identified them as giant varieties of "), _c('em', [_vm._v("Lepidodendron,")]), _vm._v(" whose roots branched into the rock beneath. “Great care should be taken in removing pieces,” he warned, because of the “danger of being killed from the unexpected launch of a huge fossil.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n37"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n37a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" Gesner avoided the falling trees, but he "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("missed the theoretical importance of the fossil forest. He did not dwell on the connections between the trees, the roots, and the coal. He spent most of his time on how to mine the Joggins. Geology was useful only when it acquainted the government “with the sources of public wealth and economy.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n38"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n38a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Profit, not theory, was the dominant theme of Gesner’s book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond its economic power, coal represented moral progress. It was evidence of “the resources Providence has placed within [Nova Scotians’] reach.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n39"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n39a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Like many at the time, Gesner saw the hand of God in nature. He was a deeply religious man who found no conflict between the account of creation in Genesis and the geological record. “There is no necessity for making the world appear older than its date given by Moses,” he insisted."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n40"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n40a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Gesner viewed the erratic boulders scattered across the landscape as evidence for Noah’s Deluge, as had Jackson and Alger. All three referred to the high authority of the Reverend William Buckland’s "), _c('em', [_vm._v("Reliquiæ Diluvianæ")]), _vm._v(" (1823)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n41"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n41a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" All three relied on sudden and great catastrophes to explain certain geological features. Gesner explicitly rejected Lyell’s theory of “one class of causes” and asked rhetorically, “have all these changes taken place by the influence of causes now operating upon the surface of the earth?”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n42"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n42a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Gesner, as well as Jackson and Alger, thought the answer was definitely no.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner’s combination of piety, practical geology, and folksy prose proved very popular. According to another native of Nova Scotia, the geologist John William Dawson (1820–1899), Gesner’s book was “extensively circulated in the province” and was “of great service in directing popular attention” to geology and mineralogy."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n43"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n43a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Gesner had intended his "), _c('em', [_vm._v("Remarks")]), _vm._v(" “for the perusal of the general reader,” which is why he had organized the book by townships, for easy reference, and added short pieces on local history, like his own shipwreck near Brier Island in December 1821."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n44"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n44a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" He sent a copy to the lieutenant governor, Sir Colin Campbell (1776–1847), and presumably one to the House of Assembly. In return he received a vote of thanks and £100 from the House “as a mark of the estimation in which they held his services.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n45"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n45a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More than anything else, this gift of political and financial support angered Jackson and Alger. They had not thought to send their essay to Campbell or the legislature. Instead of a popular book, they had written “purely for the advancement of Science without any expectation of pecuniary reward.” “[The] Memoir,” they later explained to Campbell, “was contributed freely to the Scientific World no copies having been offered for sale on their account.” One hundred copies were distributed to learned societies around the world. “Since we have served the Province as pioneers in its Geology,” they continued, “we should be wanting in justice to ourselves did we not humbly claim that our services should be acknowledged in a similar manner to those of the Gentleman [Gesner] "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("whose essay we have noticed.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n46"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n46a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" Campbell elected not to respond, which only infuriated them. In a follow-up letter to the House of Assembly, Jackson and Alger exploded, and this time they hit hard upon Gesner’s ethics. “[The Authors] must add that a large portion of his work has been borrowed from them without a candid acknowledgement—that their work has served as the model and basis of his, that discoveries & observations made by them, either appear as his own, or are referred to others.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n47"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n47a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Accusing a native son of surreptitious science surely did not endear Jackson and Alger to the Nova Scotians. The “Bluenoses,” as descendants of the Loyalists were known, were not particularly predisposed to Yankees. Not surprisingly, Jackson and Alger’s demands went unattended."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n48"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n48a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frustrated in Nova Scotia, Jackson turned to the scientific community at home. In a biting letter to Benjamin Silliman Sr., editor and founder of the "), _c('em', [_vm._v("American Journal of Science,")]), _vm._v(" he denounced Gesner for “literary larceny.” “Pray you have seen ‘Gesner’s Geol. of Nova Scotia’? The creature has swallowed our whole Memoir & then brought it up again in an undigested state & styled it a new book!! … He actually knows nothing about either Mineralogy or Geology.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n49"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n49a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Silliman advised his friend to make the matter public. Jackson decided against this. Undoubtedly it would have been difficult to prove plagiarism, and it certainly would have done him no good in Nova Scotia, where he most coveted recognition."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n50"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n50a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Jackson contented himself with the knowledge that Gesner’s "), _c('em', [_vm._v("Remarks")]), _vm._v(" would not be reviewed in Silliman’s "), _c('em', [_vm._v("Journal,")]), _vm._v(" and it would remain missing from many other American reviews."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n51"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n51a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From a historical perspective, the Jackson-Gesner dispute reveals the difficulties surrounding priority and patronage faced by many American geologists. Gesner had undertaken his survey without official government support but had skillfully courted the lieutenant governor and the House of Assembly. Jackson and Alger could lay claim to pioneering science, but that did not produce political or pecuniary thanks. Years later, Jackson tried to explain what he thought might be the consequences of this mismatch between recognition and rewards. “It is not to be expected that men of science will devote their lives to increasing the sum of human knowledge, if their labors are not appreciated and honored [and] if ingratitude and base envy meet them at every step.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n52"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n52a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Priority could be conferred within the confines of an elite group; patronage could not. For all the rhetoric about the diffusion of scientific benefits, in this instance Nova Scotians disregarded Jackson and Alger. Gesner, by contrast, spoke directly to an enlightened public and a commercially minded government. And it paid off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides the money, Gesner gained another asset, legitimation. As part of professionalization, scholars have treated legitimization as an internal, peer-reviewed process of setting standards, recognizing priority, and distributing credit and kudos."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n53"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n53a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Gesner’s legitimation was of a different sort. By valuing his "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("survey, Nova Scotia bestowed a good measure of authority on him and esteemed him as reliable, competent, and useful. In a word, Gesner became an expert.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('em', [_vm._v("The Great Coal Field of New Brunswick")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("In contrast to Nova Scotia, the economic outlook for early nineteenth-century New Brunswick was overcast. The province had no coal mines, railroads, or manufactories; its sole export was timber. Under the Navigation Acts, New Brunswick enjoyed a privileged trading position, but so dependent had it grown upon timber exports to Britain that it had to import foodstuffs, manufactured goods, and practically everything else. New Brunswick was basically a community of lumberjacks and timber merchants. Fredericton was the political capital, but Saint John was the largest commercial city and cultural center. Its Loyalist, mercantile elite dominated the House of Assembly."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n54"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n54a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the 1830s Britain’s Parliament began debating whether to continue protective policies or to open British markets to free trade. For New Brunswick, this would mean removing discriminatory tariffs on Baltic timber. Parliament’s debate over free trade coincided with another equally important one over responsible government. As a crown colony, New Brunswick’s executive government—lieutenant governor, judges, and other prominent officeholders—were appointed (or approved) and paid for by London. In 1837 the House of Assembly agreed to assume the costs of executive government; in return London relinquished the revenues and responsibilities for crown lands—about 26,000 square miles (or 16.5 million acres) of wooded preserve in the north. For the moment, tariffs remained on Baltic timber, but it would only be a matter of time before New Brunswick lost that protection. To a small group of reform-minded politicians, bankers, and capitalists, the impending storm required a new economic tack. A survey of mineral and agricultural resources might be just the thing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner’s patron in New Brunswick was the lieutenant governor Sir John Harvey (1778–1852). Appointed by the Liberal government in London to supervise the handover of crown lands and revenues in June 1837, Harvey identified with colonial reformers and encouraged commercial interests. He was a leader who understood coal, or at least Gesner assumed so when he addressed several open letters to him that summer. Published in the "), _c('em', [_vm._v("New Brunswick Courier")]), _vm._v(" (Saint John), the letters depicted the province’s potentially rich, yet unsurveyed resources."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n55"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n55a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harvey, however, did not have the power to create a geological survey. The lieutenant governor neither initiated nor controlled the expenditure of public funds; the House of Assembly determined how and where money was spent. Harvey did have a key ally in Charles Simonds (1783–1859), Speaker of the "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("House and president of the Bank of New Brunswick, one of the province’s largest and based in Saint John."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n56"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n56a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" Simonds shared Harvey’s views on the need for a broader commercial base. The House of Assembly did not; the legislators disliked provincial plans, such as hospitals, schools, and surveys. They preferred to direct public money to local projects, particularly road building within their own districts. But in 1838, the House of Assembly got its hands on a big pot of money. Revenues more than doubled to over £200,000 with the financial windfall from the crown lands."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n57"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n57a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" New Brunswick could now indulge in a survey. But how to organize one?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Surveys, as functions of government, were just beginning to take shape in the 1830s in both Britain and the United States, the two models for New Brunswick. In Britain, the gentlemanly specialist Henry De la Beche (1796–1855), through personal connections with prominent politicians and gentlemen of science, had been able to turn an ad hoc job of coloring geological features onto Ordnance survey maps of Devonshire into a secure, salaried, and permanent position as director of the Geological Survey of Great Britain from 1835 until 1855."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n58"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n58a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" American government support for geology had likewise begun on an experimental basis, albeit somewhat earlier. In the 1820s, North Carolina and South Carolina supported summertime reconnaissances by resident professors of natural history. The first statewide survey, involving annual appropriations and progress reports, was initiated by Massachusetts in 1830. By 1836 eight states, including New York and Pennsylvania, had surveys. Unlike Britain, however, American surveys were designed as short-term government expenses."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n59"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n59a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The New Brunswick survey confected a bit of both models—a dash of British gentlemanly preference with a dollop of American legislative accountability—to produce an unprecedented colonial organization of a different flavor."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n60"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n60a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" In April 1838 Harvey appointed Gesner the provincial geologist. The House of Assembly grudgingly appropriated £200 for the first year, but only token support thereafter."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n61"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n61a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" In return, legislators wanted annual progress reports. They also specified the survey’s goals—“the discovery and application of such [mineral] substances as have been found most important to the interest and support of commerce, agriculture, and manufacture.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n62"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n62a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" The principal ones were coal and iron. Further, they instructed Gesner "), _c('em', [_vm._v("where")]), _vm._v(" to explore. They directed him to the coast, extending southward and westward of Saint John, from the river to the American border. Such geographical constraints contrasted sharply with American surveys where funding flowed from the promise that geologists would cover the "), _c('em', [_vm._v("entire")]), _vm._v(" state and examine "), _c('em', [_vm._v("all")]), _vm._v(" the rocks."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n63"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n63a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" New Brunswick, like Britain, began in a targeted location.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For his first season of fieldwork, Gesner followed the pattern he had developed in Nova Scotia. Starting in Saint John, he went from township to township looking for useful minerals. In effect, he retraced the path of a consulting "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("trip he made in 1837, when a coal mining company had hired him to explore the lower St. Croix River, the islands off the coast, and other parts of Charlotte County."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n64"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n64a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" This overlap between private and public surveying was not uncommon. Wealthy landowners and prospective capitalists, if not in government themselves, had enough political clout to ensure their properties received attention. Gesner visited the estates and farms of several prominent individuals, although he chose "), _c('em', [_vm._v("not")]), _vm._v(" to investigate the salt springs “on lands owned by his Honor the Chief Justice.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n65"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n65a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" In this instance, complementary interests might have been misconstrued as a conflict of interest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner’s ability to fulfill the House of Assembly’s instructions resulted in funding for another year and emboldened him to broaden the survey’s scope beyond mining and agriculture. He thought the “the discovery of rocks” with a view to ordering them and explaining their origin might also be useful. He presented a plan with equal weight on “scientific” and “economical” geology. New Brunswick now fell more in line with contemporary American surveys."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n66"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n66a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet the distance between Gesner’s broad geographical view and the House of Assembly’s myopia remained, and it undermined the survey."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n67"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n67a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" During the first three years, Gesner was told to concentrate on a handful of counties—Charlotte, Saint John, Kings, Queens, and Westmorland. Located along the Bay of Fundy (with the exception of Queens), these counties had the largest populations, the most cleared and cultivated land, and the best roads. They were the places most likely to support a survey."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n68"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n68a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" They were also relatively close to Saint John, where Gesner had moved in 1838, and which served as the survey’s headquarters. The northern timber counties and central ones like York, where Fredericton was located, made few, if any, demands for geology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During his second season (1839), Gesner began in Saint John County, ventured up the coast to the head of Shepbody Bay, and then turned inland via the Petitcodiac River. In Westmorland County he found a big coal field, “a tract of country, one hundred and fifty miles long, and, upon average, forty miles in breadth.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n69"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n69a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" The size of this surprising coal field “scarcely require[d] remark.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n70"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n70a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" In fact, Gesner did not get much chance to study the structure, extent, or quality of the coal, even after he returned to Westmorland County the following year. Instead, the legislature required him to spend his third season reexamining Saint John County. Only after completing his resurvey of the coastal counties did Gesner get to go north and west. In Queens County, he discovered an iron ore deposit and more coal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coal had been known to exist in a few places along Grand Lake since at least the mid-1830s. A seam about two feet thick had been opened by the Salmon River Coal Company, a relatively large mining operation and one Gesner had close contacts with."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n71"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n71a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" The coal was difficult to trace, however; the seam lay covered by sandstones or loose soil, and the strata were very nearly horizontal.")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('a', {
    attrs: {
      "id": "fig2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Abraham Gesner’s geological survey of New Brunswick (1838–1842).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("Moreover, it was impossible to estimate the field’s size because the entire northern part of the province had yet to be explored."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n72"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n72a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Nonetheless, Gesner believed the coal of Grand Lake might extend northward to Bathurst, a distance of 150 miles, eastward to Shediac, a distance of 70 miles, and westward beyond Fredericton. It was a big coal field. “This tract,” Gesner speculated, “may bear the reputation of being the largest coal-field ever discovered on the globe.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n73"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n73a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" He dubbed it the “Great New-Brunswick Coal-Field.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner planned a thorough exploration, but before he could get started, the political situation changed dramatically. In 1841 Sir William Colebrooke (1787–1870) replaced Harvey as lieutenant governor. Harvey’s dismissal came in response to complaints about his failure to repel American encroachments along the upper St. John River. In that area, the exact boundary between the United States and British North America had been in dispute ever since the 1783 Treaty of Paris had ended the American Revolution. The treaty defined the boundary as the “high lands” separating rivers flowing north into the St. Lawrence from those flowing south into the Atlantic. The British had vital military interests in controlling the highlands; they provided the only overland route for moving troops between Halifax and Québec. Some in New Brunswick were also looking to build a railroad through the region. American interests were primarily economic; Maine wanted to expand logging operations into the Aroostook River valley. The climax of the “Aroostook War” came in late 1840 when Maine militia forces encountered British infantry. Not a shot was fired. Neither London nor Washington wanted war, but Harvey’s position had been compromised by indecision. (John Fairfield, the Democratic governor of Maine, also lost his bid for reelection because of alleged military hesitation.) In 1842 a settlement was reached through the Webster-Ashburton Treaty. Britain retained the highlands, but Maine got the majority of the Aroostook pine."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n74"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n74a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maine acquired other potentially valuable resources. The boundary was surveyed by none other than Jackson. In 1836 Maine had organized a geological survey under Jackson’s direction, but unlike Gesner, Jackson worked in the disputed territory and described in detail the mountains, rivers, lakes, and resources. According to Gesner, Maine’s government “spared no pains or expense in obtaining accurate knowledge.” Jackson’s survey thus “afforded the United States a great advantage.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n75"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n75a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given the new political climate and Jackson’s exploratory encroachments, Colebrooke instructed Gesner to move into the timber regions along the boundary. “In consequence of the late dispute,” Gesner explained, “it was necessary to obtain as much information as possible in regard to the nature, resources, and value of the district claimed by each of those powers.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n76"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n76a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" Gesner traveled up the St. John River to Woodstock, where Jackson had recently uncovered iron ore."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n77"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n77a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" Gesner then followed the Mirimachi and Nashwaak rivers. "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("What he found in the forests astonished him—the great New Brunswick coal field. “From all the observations I have been able to make, it is now known to embrace an area of seven thousand five hundred square miles!!! If the Westmoreland Coal Field also belongs to this carboniferous deposit, the whole area may be computed at eight thousand seven hundred square miles.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n78"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n78a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" Gesner could barely contain his enthusiasm. He listed coal’s many uses, all of which were very familiar, but apparently not of great interest to the House of Assembly. In 1842 legislators cut the survey’s funding.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Colebrooke, nonetheless, commissioned Gesner to continue his work, without pay, and sent him, again, to “the territory recently in dispute between Great Britain and the United States.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n79"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n79a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" Prominent merchants in Saint John loaned money to him, and the directors of the Saint John Mechanics’ Institute planned to purchase his collections of minerals, fossils, and other specimens for £1,000. (Gesner was, at the time, the institute’s vice-president.)"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n80"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n80a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" So for another year Gesner explored the northern timber counties. He followed the upper St. John River, the Tobique River, and, in the most northern reaches, the Restigouche River and the Bay of Chaleur. “The knowledge heretofore possessed of some vast and important tracts of land within the Province,” he reported, “was confined to a few lumbermen.” The land was “unoccupied even by the native Indians.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n81"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n81a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner asked for support for “the labour of another season, which would complete the geological survey of the whole Province.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n82"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n82a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" In his argument, he summarized the numerous advantages already accruing from his work. First, there were the marl and limestone deposits, mineral fertilizers that had not previously been used in New Brunswick. Gesner admitted that New Brunswick farmers were predisposed against such fertilizers, perhaps because they were not widely used in Britain, but he noted that American farmers reaped good returns from judicious trials. More generally, Gesner thought his description of “millions of acres of excellent lands” in the province’s interior would be a great benefit to farmers."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n83"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n83a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for minerals, Gesner spoke with pride of his discovery of granite and other building materials. “Formerly, all the granite was imported from the United States or Nova-Scotia.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n84"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n84a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" But by 1841, he declared, “upwards of six thousand tons” had been quarried and shipped to Fredericton, Kingston, and Saint John, which was busily rebuilding after a devastating fire in 1839. Gesner listed “extensive” deposits of iron, copper, lead, and manganese, in addition to “deposits of salt [and] gypsum,” which, he predicted, “may hereafter become the sources of wealth.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n85"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n85a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, there was coal. Prior to his survey, coal had to be imported from Nova Scotia. Gesner’s discoveries would change all that, "), _c('em', [_vm._v("if")]), _vm._v(" New Brunswick could attract investors. “There is scarcely any quarter of the globe where British capital and science are not employed in mining pursuits,” he explained. “If it be enquired "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("why foreign countries have received so many advantages from this source, while the British North American Provinces have been neglected, it will be seen, that in the former, the objects of wealth have been made known, while in the Colonies the discovery of similar objects has been neglected.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n86"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n86a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" In short, further study of the great New Brunswick coal field would lead to British investment."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n87"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n87a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the meantime, local capitalists, inspired by Gesner’s glowing reports, had taken mining leases on properties within his great coal field and started to dig. But they did not get far before the ventures failed. And it is not entirely clear why. Gesner suspected they were not begun in the right fashion and advised that, “before much capital is expended in opening these mines, the most careful, patient, and scientific examination should be made.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n88"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n88a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" Mining companies must first consult geologists. Gesner was not touting for custom; in fact, he endorsed the “accomplished” English geologist W. J. Henwood."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n89"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n89a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" Rather he was arguing for an extension of his survey and, simultaneously, delimiting the boundaries of his position. As provincial geologist, he was “to assist” New Brunswick capitalists by pointing out the “new and most important objects of enterprize and wealth,” although he warned “it is not the object of a Geological Survey to extend its operations to the absolute working of any mine.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n90"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n90a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite his efforts to forestall criticism, complaints about coal mining reached the House of Assembly. Whether it was the failed ventures or the loss of Harvey’s patronage, Colebrooke did not reappoint Gesner. The New Brunswick survey came to its official end in 1843.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner anticipated it would. The tone of his last government report was remarkably subdued. The usually upbeat Gesner made no mention of his great coal field and said very little about coal in general. His resigned economy of words reflected a gloomy outlook. New Brunswick was in recession. British timber preferences had been sharply reduced, and revenues from timber leases had declined. The unrestrained spending of the previous four years had put the province in debt by 1841. Gesner, however, did not think the fault for any business failures lay with his survey or his science, but with bad commercial practices. Mining leases had been secured “for the sole objects of speculation, and not for their actual workings,” he retorted. He could not be held responsible for recklessness; “such things [were] common to all new discoveries.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n91"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n91a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" Moreover, Saint John capitalists, in contrast to those in Halifax where commercial caution prevailed, had a reputation for “rash and improvident speculation.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n92"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n92a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" Perhaps this was why Gesner favored British ones. In the end, the survey was not discontinued because of sour mining deals. As Gesner flatly declared, “the embarrassed state of the finances of the Province” did him in."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n93"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n93a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nonetheless, “[t]here is,” Gesner observed, “in the examination of the natural productions of the country, an object to be gained beyond the benefits arising "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("from the discovery of useful minerals.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n94"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n94a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" The scientific results of the New Brunswick survey were substantial—the best geology in British North America—and much clearer than his Nova Scotia account. Gesner identified Primary formations in an extensive and moderately elevated chain of mountains running along the Bay of Fundy coast. In the province’s southern part, he found rocks belonging to the Transition, a term he used in his first report, but soon replaced with Greywacke, and later Cambrian and/or Silurian. Secondary formations, principally the Coal and New Red Sandstone, occupied most of the large, central part of New Brunswick. Tertiary rocks were found in the northern counties of Restigouche and Gloucester.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In describing these formations, Gesner relied on lithology. He mentioned fossils and even listed a few from the Coal, but as for a systematic study of animal and plant remains, he confessed, they were “too numerous, and frequently too complex in their characters.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n95"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n95a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" In identifying the formations, he turned to British authorities. Gesner listed eight, sometimes nine, “systems”; the number fluctuated as he debated whether to adopt Adam Sedgwick’s “Cambrian” or Roderick Impey Murchison’s “Silurian” for the oldest fossiliferous strata of the Secondary."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n96"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n96a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" Gesner did not try to correlate New Brunswick rocks with American formations, and he rejected the practice, recently adopted by New York geologists, of using local names for formations. The idea of coining names, such as “Nerepis, Mispeck or Quaco rocks,” simply invited ridicule and confusion. Formations, Gesner declared, should be recognizable “in every quarter of the globe.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n97"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n97a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" He thus deferred to British geologists. “I have been induced to use the names employed by those gentlemen,” he reasoned, “not only because their important divisions have been sanctioned in Europe, but from the applicability of the descriptions attached to them to the rocks of New-Brunswick.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n98"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n98a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Overall, Gesner’s five annual reports (1839–1843) were not designed to deal with problems of correlation. Basically, he had made detailed lists of what he saw, not theoretical explanations of how it got there. His geology was more inventory than inventive."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n99"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n99a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" In fairness to Gesner, this was what was expected of him. Surveying for the sake of science was not his job. On occasion, and when appropriate, he did theorize about geological causes. In his account of river terraces and boulders scattered over the land, for example, he addressed “the glaciel ["), _c('em', [_vm._v("sic")]), _vm._v("] theory” of Louis Agassiz (1807–1873)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n100"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n100a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" He admitted that in other countries, such as Agassiz’s Switzerland, mountains might be covered with “eternal snow,” but he did not think the New Brunswick highlands were high enough for glaciers. To explain the terraces, Gesner relied on sudden drops of the riverbed, although he proposed no explanation for the change in elevation. As for the scattered boulders and the parallel scratches and grooves "), _c('em', [_vm._v("(striæ)")]), _vm._v(" on some rocks, Gesner invoked a sudden and violent rush of water over the land. "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("In contrast to his Nova Scotia geology, he did not explicitly refer to Noah’s Flood. Gone too were other references to the Bible. Gesner, of course, did acknowledge “the power and goodness of [the] Creator.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n101"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n101a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His reports were written in a familiar travelogue style. They contained practically no diagrams, sections, or maps. Although he continually spoke of completing a geological map, he never published one. He did include numerous woodcuts depicting nature, which coupled with his account of his explorations could be quite moving.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotd1"
  }, [_vm._v("One mile above the Indian village there is a dangerous rapid, called the Narrows. The [Tobique] river at this place passes through a gorge a mile long, and upon average only one hundred and fifty feet wide, and between perpendicular cliffs from fifty to one hundred feet high. . . . In descending, the Indians were anxious to “shoot the rapid,” as it is called, and we were carried through the opening with almost inconceivable swiftness."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n102"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n102a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("Shooting the rapids was a relatively rare and exciting event in Gesner’s reports. Native Americans, along with their villages and terms for local landmarks, appeared frequently, because they guided him through the thick forests. Moose, caribou, and lazy bears, on the other hand, were missing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His general tone was more serious than his Nova Scotia book, a reflection of change in his intended audience—the New Brunswick government rather than the reading public. Gesner was also keenly aware that his reports were to be distributed in Britain, and occasionally he addressed “persons abroad” who might emigrate to New Brunswick and take up and clear the tracts of ungranted land in the interior. At other times, he targeted his discussions to British geologists.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1840 his pioneering efforts were rewarded with a fellowship in the Geological Society of London. This honor, however, required some political finesse. At the start of the survey, Gesner had written to the society requesting information on how to become a member. He was told that because he resided in New Brunswick he could not become one."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n103"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n103a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" This was to be regretted, Gesner replied, especially because he was the first official geologist of a crown colony. Somewhat peevishly he added that he would not be forwarding New Brunswick minerals and fossils. “It will be but right to bestow them upon such an Institution as will allow their donor the most favorable consideration.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n104"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n104a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" Gesner soon received confirmation from Lyell, then vice-president, that he would be elected a fellow."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n105"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n105a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner’s fellowship illustrates how a geologist, far removed from the metropolis, could leverage the specimens of a distant land and the authority of a government appointment into scientific rewards. It also reflects Lyell’s fascination with America. The two might have met during Gesner’s brief stay in London. "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("Lyell certainly read Gesner’s account of the fossil trees at the Joggins and was “particularly desirous” to see them. So he arranged to meet Gesner in July 1842."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n106"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n106a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lyell had arrived in America in August 1841 and had spent the year geologizing in the United States. When he contacted Gesner, Gesner was busy shooting the rapids, but directly afterward went to meet Lyell at Parrsboro. They spent two days studying the 100-foot cliffs of the Joggins. Lyell was impressed. Along two miles of coast, they measured a section of sandstone, shale, and coal strata amounting to more than 2,000 feet of deposition. They counted nineteen coal seams, some as much as four feet thick, and seventeen vertical trees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Immediately below this coal section, Lyell found beds of gypsum, limestone, and red sandstone, which he called the Gypsiferous formation. Lyell located this gypsum group "), _c('em', [_vm._v("below")]), _vm._v(" the Coal formation, an interpretation that conflicted with Gesner’s (and Jackson and Alger’s)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n107"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n107a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" Gesner had placed the gypsum group as part of the New Red Sandstone formation, which lay "), _c('em', [_vm._v("above")]), _vm._v(" the Coal. In separate articles to the Geological Society, Lyell and Gesner debated the proper stratigraphical location of the gypsum."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n108"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n108a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Much depended on the interpretation; if Gesner were correct, large tracts of coal might still lay hidden. If Lyell were correct, the search for coal in parts of Nova Scotia "), _c('em', [_vm._v("and")]), _vm._v(" New Brunswick (especially in Westmorland County) would be fruitless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner, the provincial surveyor, did not stand alone against Lyell, the cosmopolitan geologist. William Logan (1798–1875), a Montreal-born geologist who had apprenticed in the Welsh coal fields in the 1830s, toured Nova Scotia in 1841, and he too placed the gypsum group with the New Red formation. Logan’s stratigraphy, like Gesner’s, was based largely on lithology and relative position. But Logan also collected fossils, which he brought back to London to show to Murchison and the French geologist Édouard de Verneuil. After studying them, Murchison and de Verneuil confirmed the location of the gypsum group in the New Red formation."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n109"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n109a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But this did not end the debate. During the 1840s, Dawson took up the correlation question. In October 1847 he presented a detailed survey of the gypsum group, which he argued should be placed in the lower part of the Coal formation, that is, "), _c('em', [_vm._v("below")]), _vm._v(" the Coal, as Lyell had thought."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n110"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n110a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" In 1849 Gesner agreed. In a brief note to the Geological Society, Gesner took “pleasure in confirming the views held” by Lyell."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n111"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n111a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" The Gypsiferous formation of Nova Scotia lay "), _c('em', [_vm._v("below")]), _vm._v(" the productive Coal Measures. The debate between Lyell, Dawson, and Gesner thus highlights how far, scientifically speaking, Gesner had come from the early 1830s (when Jackson and Alger avoided mentioning him in print) to the early 1840s (when Lyell sought him out). Gesner had established a reputation as a man of science based on his pioneering work in New Brunswick.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The robustness of that reputation was tested in later discussions of the most "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("contentious aspect of Gesner’s survey—the great New Brunswick coal field."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n112"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n112a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" L. W. Bailey (1839–1925), a member of the Geological Survey of Canada in the 1890s, explained that Gesner’s coal field was very thin, and although it extended over a large area, as Gesner had outlined, its shallow depth resulted in very few mining possibilities."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n113"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n113a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" G. F. Matthew (1837–1923), another survey member in the 1890s, wrote a very sympathetic sketch of Gesner in which he pointed out “the error” of expressing a too “favorable” opinion on mineral wealth."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n114"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n114a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" In contrast, Gesner’s contemporary, James C. Robb (1815–1861), the first professor of chemistry and natural history at King’s College (later renamed the University of New Brunswick) in Fredericton, criticized him for unwarranted optimism. “The Great New Brunswick Coal Field,” Robb chided, “certainly is very considerable, although it is not ‘one of the largest area[s] discovered on the Globe.’” Rather, “it is sufficiently obvious that the importance of the [coal beds] has been over-stated, while the probability of finding others of greater thickness and improved quality, has been much exaggerated.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n115"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n115a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" Robb’s opinion appeared in an agricultural report on New Brunswick prepared by the Scottish chemist James F. W. Johnston (1796–1855), who had a subtler understanding of the inherent difficulties of survey geology.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquoterd"
  }, [_vm._v("[L]ike all men whose fate it is to pioneer the way to new views, new studies, and new habits of thought, [Gesner] evidently writes as if he felt his work to be very much up-hill—as if he were laboring for men who did not generally understand or appreciate his task, and he was therefore induced occasionally to minister a little too strongly to the vulgar views of immediate profit from scientific inquiry, and thus create expectations which his own labours did not realize."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n116"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n116a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("Commercial predictions were risky, though at times necessary. Optimism might be confused with misrepresentation, a behavior unsuited to a man of science.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From a historical perspective, the significance of Gesner’s New Brunswick survey is mixed. He undoubtedly provided the first detailed descriptions of the rocks of a hitherto unexplored region, but he studied less than half of the province, an unfinished job he sorely wished to complete."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n117"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n117a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" As far as coal went, the field was great geographically, not commercially.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The final irony may be that New Brunswick got what it paid for. Parochial politics produced patchy science. Unlike American surveys, where democratic governments required more representative coverage, including, in the case of Maine, lands not yet belonging to the state, the New Brunswick House of Assembly could not see the value of a province-wide view. Colebrooke called the way legislators distributed money a highly organized system of corruption."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n118"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n118a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" Gesner thought it “a system of extravagance.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n119"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n119a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" That is not to say American state governments were not prone to corruption or wasteful expenditures when it came to internal improvements. But in New Brunswick’s system of narrow-based "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("patronage where each faction and every community were concerned with promoting their own immediate interests, geographic range and scientific autonomy were limited.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('em', [_vm._v("Scientific Entrepreneurship")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("The circumstances of Gesner’s dismissal were peculiar to New Brunswick, but the survey’s termination would not have surprised any American geologists. Whether a survey was completed or not, unemployment eventually came to all surveyors. They then faced the arduous task of earning a living by pursuing their science. Gesner, like many American men of science, was not independently wealthy and thus did not have the leisure to geologize. Nor did he have an academic position to fall back on. He had tried to secure an appointment as lecturer in chemistry and natural history at King’s College, New Brunswick, in 1837, but that position had gone to Robb."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n120"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n120a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" In general, teaching positions in the first half of the nineteenth century were scarce, especially in British North America. Gesner thus needed another means to a scientific end.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Scientific entrepreneurship refers to the ways in which men of science like Gesner tried to make a livelihood using their knowledge, experience, and social contacts."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n121"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n121a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" It is a broad category encompassing a variety of employments and career paths chosen for scientific and personal advancement, including other government surveys, academic positions, public lecturing, popular writing, and consulting. The usefulness of scientific entrepreneurship as an analytical concept lies in its highlighting the temporary nature of these varied positions and the required effort of self-promotion to obtain them. Scientific entrepreneurs had to convince others of their expertise and the advantages of their science. Further, the concept forces a serious evaluation of the degree and kind of accommodations men of science made and were willing to make, as they attempted to weigh the issue of how much “science” versus how much “enterprise.” What balance was to be struck between the pursuit of research and the provision of practical results? These questions are similar to those generated by government surveys, and, not surprisingly, surveys fitted geologists for enterprising careers afterward. But not all scientific entrepreneurs had the benefit of government appointment and hence the legitimation derived from such authority. Creating and maintaining a reputation for honesty and competence was a new and challenging ethical problem for many midcentury American men of science.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner was forty-six years old when he lost his New Brunswick position. He returned to his father’s home in Cornwallis, Nova Scotia, where he made another desultory effort at farming and a reluctant stab at doctoring. Gesner, however, considered himself a man of science. And between 1843 and 1849 he undertook "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("a number of scientific projects. Public lecturing, for example, suited his interests and outgoing personality very well. He demonstrated the latest scientific findings and fads, such as galvanism, and drew large audiences and widespread publicity. One of his most famous performances, delivered at the Saint John Mechanics’ Institute in March 1843, involved the animation of the head of a freshly killed ox. In dramatic fashion he showed that muscles could be stimulated by an electrical jolt; he made the dead beast’s eyelids open and close. In this instance, and in many others, Gesner effectively mixed spectacle with respectability and thus entertained as well as enlightened his audiences."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n122"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n122a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides lecturing, Gesner continued surveying, both public and private. In the summer of 1846, he made a reconnaissance of Prince Edward Island and wrote a brief fifty-page report, for which the government granted him £200."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n123"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n123a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" That same year, he consulted for a group of Halifax capitalists about iron ore near Londonderry. He considered it “the richest and most valuable deposit” in Nova Scotia."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n124"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n124a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" In general, though, surveying presented limited opportunities. There were only six colonies in British North America, and the number of mining companies was distressingly small, despite Gesner’s untiring efforts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In contrast, the situation in the United States was booming, as illustrated by Jackson’s career. As mentioned previously, Jackson had surveyed Maine while Gesner worked in New Brunswick. In 1839, after three years of fieldwork, a financial downturn brought that survey to an end. Jackson, however, managed to land two other government positions. In Rhode Island, with the help of the Society for the Encouragement of Domestic Industry, he received a one-year appointment (1839–1840) to make a geological and agricultural survey, and in New Hampshire he organized a four-year geological and mineralogical survey (1839–1842)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n125"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n125a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" In 1847 the federal government appointed him to the post of geologist-in-charge of surveying the public lands around Lake Superior. Jackson’s serial surveying was not unusual. Many American geologists worked on multiple surveys (state and federal) during their careers. Prior to the Civil War, twenty-eight of thirty-four states began geological surveys, a large number that reflected both the ever-increasing territorial size of the United States and its growing industry, especially mining. Jackson did have the advantage of experience and of location; Boston was home to several capitalists looking to consult a geologist about their mines and properties. During the 1840s and 1850s, consulting became such a lucrative, professional practice in the United States that it emerged as the dominant expression of scientific entrepreneurship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Barring a move to the United States, Gesner had to find another way to make a living as a geologist. He chose popular writing. Authorship was a familiar kind of scientific entrepreneurship in Britain. Lyell, for one, had shown how to make money selling geology books. Gesner, of course, was no Lyell in terms of scientific or social standing. And neither was Nova Scotia anything like the British "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("market for books and popular culture. As a result, the two books Gesner published in the 1840s were less about geology than about political economy, and they were directed more at a British audience than one at home."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n126"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n126a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" As a self-described reformer, Gesner presented his books on New Brunswick and Nova Scotia as templates for change. Science, generally, and geology, specifically, would be guides to progress and improvement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his sweeping guidebook entitled "), _c('em', [_vm._v("New Brunswick; with Notes for Emigrants")]), _vm._v(" (1847), Gesner presented the most comprehensive account of the province’s natural phenomena as well as a history of its native peoples, European settlements, Loyalist families, and recent British immigrants. It contained “all the information acquired during the performance of public service,” Gesner explained."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n127"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n127a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" He described the land, town by town, and addressed all possible employments—hunting, trapping, fishing, farming, lumbering, and, of course, mining. Published in London, the book painted a bright picture of British North America, a part of the world often mistakenly characterized by its frigid climate, dense fogs, and endless wilderness—what Gesner called “the great moose yard.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n128"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n128a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within the fabric of facts and figures, Gesner wove a plan to capture the “redundant population and dormant wealth” of Britain. He wanted to increase investment in New Brunswick and to encourage emigration of “respectable” persons, those with capital of £25, £50, or £100. He opposed the Irish. Those impoverished immigrants had been arriving in large numbers, although they tended to leave New Brunswick because of paltry opportunities. What few jobs existed were in lumbering, a regrettable situation because it signaled continuing reliance on one export. “The enterprise of the country,” as Gesner called it, was bound up to such an extent with the timber trade that all other industry scarcely existed."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n129"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n129a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" His favorite example of a neglected industry was, predictably, mining. He praised the “great mineral wealth” of New Brunswick, but his own survey had failed to encourage that industry. The great New Brunswick coal field supported just two mines in Queens County."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n130"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n130a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" Gesner conceded that mining “will probably remain inactive until the timber resources have failed.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n131"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n131a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only foreign investment could develop the mining industry, a theme Gesner developed more fully in his next book, "), _c('em', [_vm._v("The Industrial Resources of Nova Scotia")]), _vm._v(" (1849). From a cursory glance, it looked a lot like the one on New Brunswick, a business prospectus for the province based on a thorough inventory of its “natural wealth”—plant, animal, and mineral. (It was dedicated to Harvey, his former New Brunswick patron, who in August 1846 became the lieutenant governor of Nova Scotia.) On closer examination, it presented Gesner’s mature views on geology, coal, and progress through a serious and sustained critique of the kind of capitalism promoted by the Nova Scotia and British governments. What Gesner wanted to explain (and therefore correct) was why the province was “not advanced in a degree proportionate to her resources.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n132"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n132a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("Like many British and American Whigs, Gesner saw advancement in spreading the fruits of science across the landscape in the form of mines, canals, railroads, and telegraphs."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n133"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n133a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" Internal improvements made nations prosperous and progressive. Governments were therefore responsible for promoting them."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n134"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n134a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" The reason Nova Scotia languished, while Britain, the United States, and even Upper and Lower Canada moved forward, was directly related to the "), _c('em', [_vm._v("lack")]), _vm._v(" of government encouragement. Gesner thought that Britain bore the brunt of responsibility. Not only had London failed to grant large sums of money for improvement—as it had for Canada—but individual capitalists had betrayed the British Empire by investing in American mines, canals, railroads, and telegraphs. This preference for the United States was doubly galling because many of those companies and a few state governments, most prominently Pennsylvania, had gone bankrupt."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n135"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n135a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nova Scotia deserved better, and Gesner set out to inform those at home and abroad of investment opportunities and needs. He projected a “New Britain on this side of the Atlantic.” Oddly enough, his model was not Britain, but the United States, a country undertaking “colossean public improvements.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n136"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n136a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" He admired the “superiority” that Americans displayed through their vigorous spirit of enterprise."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n137"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n137a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" Nova Scotians, by contrast, showed “little enterprize”; they followed “extreme caution” and lacked “general and persevering industry.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n138"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n138a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" Americans exceeded Nova Scotians in wealth and improvement because they had been weaned from the patronage of the mother country, a paradoxical explanation in light of Gesner’s demands for "), _c('em', [_vm._v("increased")]), _vm._v(" British investment. Nevertheless, American advancement was “not from the peculiarity of their government” (which Gesner thought was essentially British) but because “almost every natural production of their country has been collected.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n139"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n139a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" This was the heart of Gesner’s argument. Nova Scotia had sponsored “no public inquiry in reference to the natural productions and resources of the country.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n140"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n140a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" The province needed a geological survey.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquoterd"
  }, [_vm._v("The objects to which money can be profitably applied, must first be made known, before any hope can be entertained of their being rendered useful in themselves, and doubly useful by the capital they draw in from abroad. With such views the Americans have made examinations and surveys of every part of the Union from the St. Croix to Oregon. . . . Every state has its geologists, botanists, chemists, agriculturalists, and civil engineers, who are paid from the public treasury."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n141"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n141a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("If science were the basis of improvement, then it was no wonder Nova Scotia stagnated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Absent a new survey, "), _c('em', [_vm._v("Industrial Resources")]), _vm._v(" contained the best overview of Nova Scotia geology. In concise fashion Gesner outlined the major stratigraphic "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("systems—Granite, Cambrian, Silurian, Devonian, Carboniferous, New Red Sandstone, Intrusive, and Drift. In identifying various outcrops and tracing their extent, he followed Lyell’s 1842 reconnaissance. But when it came to mineral resources, Gesner asserted his own expertise. He repeated his claim to the discovery of the great New Brunswick coal field and even added a discussion of the “great Nova Scotia coal field.” Taken together, Gesner assured his readers that British North America contained 10,000 square miles of coal, which could supply fuel, sustain furnace and forge, and produce steam for “multifarious operations of manufacture.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n142"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n142a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('a', {
    attrs: {
      "id": "fig3"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Richard Taylor’s map of the coal fields of British North America. Taylor relied on Abraham Gesner’s surveys of Nova Scotia and New Brunswick, but he did not use Gesner’s report on Prince Edward Island, which showed no coal there. "), _c('em', [_vm._v("Source:")]), _vm._v(" Richard Cowling Taylor, "), _c('em', [_vm._v("Statistics of Coal")]), _vm._v(" (Philadelphia: J. W. Moore, 1848), facing page 208.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But even if Nova Scotia got the necessary British capital for internal improvement, it faced one more hurdle—foreign monopoly. Nova Scotia’s minerals did not belong to the people. The Duke of York had acquired a crown lease in 1827 to all Nova Scotian mines and minerals. He then granted sole rights under this lease to a group of London capitalists, who formed the General Mining Association (GMA)."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n143"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n143a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" The reservation of all mines and minerals to the GMA, Gesner concluded, had “retarded discoveries by the inhabitants, and checked that kind of inquiry which has been so beneficial to neighboring colonies.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n144"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n144a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Nova Scotia, coal was the principal mineral, but it was the one most “retarded” from reaching its full potential. The GMA had opened only two collieries: one in Pictou (Albion Mines) and the other in Cape Breton (Sydney Mines). There were certainly other coal fields, as Gesner had shown, but the GMA refused to mine them. Throughout the 1830s and 1840s, Gesner steadfastly opposed the GMA. “The Mining Association possesses an entire monopoly, which has prevented every kind of mining enterprise in the province … a colony that will never thrive until her resources are liberated from the fetters of unyielding monopolists.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n145"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n145a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" In 1838 and again in 1844, he petitioned the House of Assembly to open a mine at the Joggins. He even applied for a mining license himself using a legal technicality to force a hearing. According to the terms of its lease, the GMA was required to open a mine in places where coal had been found within a year of its discovery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gesner’s petition resulted in the formation of a government committee of inquiry set up in March 1845 to investigate the GMA’s monopoly. Gesner and Dawson were the star witnesses. They testified to the GMA’s deleterious effects on coal mining. The committee found that foreign countries (i.e., United States, where the GMA’s coal was being exported) received lower prices than did citizens in western Nova Scotia. The House of Assembly decided therefore not to reduce the royalty paid by the GMA on Nova Scotia coal and to force the GMA to begin mining at the Joggins, which it did, in 1846."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n146"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n146a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The opening of the Joggins mine had a decided effect on Gesner. By the time "), _c('em', [_vm._v("Industrial Resources")]), _vm._v(" appeared in 1849, Gesner had tempered his hostility toward the GMA. He now thought the GMA had brought much needed capital into the "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("province. Still, he hoped it would do more, especially in developing iron ore resources. There was still not a single furnace smelting iron ore in any of the British American provinces. That changed when the Londonderry Iron Works was established, one of the very few examples of a profitable mining enterprise before Canadian Confederation in 1867."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n147"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n147a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The publication of "), _c('em', [_vm._v("Industrial Resources")]), _vm._v(" marked the end of Gesner’s career as a geologist. In the late 1840s, he began to turn his attention toward chemistry and the commercial interests of his new patron, the audacious and famous Thomas Cochrane (1775–1860), tenth Earl of Dundonald and admiral of the British North American and West Indian fleet stationed in Halifax. Gesner had become acquainted with Dundonald while writing the book and had relied on him for information about Cape Breton. Moving to Halifax in 1849, Gesner took up coal chemistry, and he and Dundonald began work on an ambitious project—gas lighting for Halifax. By 1850, then, Gesner had moved from government geologist, through lecturing and writing, to businessman. Gas lighting would test his scientific knowledge, political experience, and personal connections (as well as those of Jackson) in the coming years.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquoteb"
  }, [_vm._v("The occupations and habits of the inhabitants of any civilized country will ever be influenced by the geological structure of the districts they inhabit."), _c('br'), _vm._v("—Abraham Gesner, "), _c('em', [_vm._v("The Industrial Resources of Nova Scotia")]), _vm._v(" (1849)")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GESNER’S ASSERTION")]), _vm._v(" was both grandiose and banal. In reducing society to bedrock, he seemed to make an extraordinary case for his science, if not his hubris. But he was not alone. Geology was the acknowledged queen of the sciences in the early nineteenth century. Romantic, adventurous, and practical, it encompassed time, land, and the raw materials of progress. Gesner’s oft-repeated slogan that coal “lay the foundation” for industry would have struck contemporaries as perfectly obvious. It is, however, historically important to understand why and how this connection between science and improvement became commonplace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Part of the answer turns on the individuals Gesner most readily identified with progress—capitalists. When Gesner spoke of capitalists, he meant a class of wealthy, upright, and enterprising gentlemen—mostly British, but also American or British American—willing to invest monetary and moral capital in developing coal mines, canals, railroads, telegraphs, manufactories, furnaces, and forges. These big industries or “technologies” had several common features. They were expensive, they were complex, and they were risky. It was never certain "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("that these improvements would return the investment, to individuals or to governments. It was therefore crucial that investors had the best advice available, precisely the kind of science Gesner could provide through government reports or private consulting engagements. In either case, science could mitigate the risks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Industry was regarded as an improvement because it returned a profit on investment and benefited the public. In this ideal framework, industry was "), _c('em', [_vm._v("not")]), _vm._v(" speculation, an ephemeral financial bubble; and capitalists were "), _c('em', [_vm._v("not")]), _vm._v(" speculators, impetuous individuals like those who did not mine the great coal field of New Brunswick. Nor was industry intended to be a monopoly, like the General Mining Association. To Gesner’s mind, improvement meant many industries and many companies—multiple capitalists and their consultants. Speculators and monopolists marked the dangerous banks of the economic mainstream. The former were too rash and too many; the latter were too stubborn and too few. There was a superior middle way to prosperity—scientifically informed investment. The link between science and progress was not abstract; it was personal and direct, between the geologist and the capitalist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were definite blind spots in this vision of scientific capitalism. Gesner, for one, did not have much to say about the laborers who mined coal, fired furnaces, laid tracks, or dug canals. He disliked Irish immigrants, precisely those who did the hard and dirty work."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n148"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n148a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" He was much more concerned with share prices, production, and equipment costs. To that extent, he shared the prejudices of the capitalists he associated with. Science entered the industrial equation at the top and informed big decisions about scope and scale, not everyday toil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It would be unfair, however, to class Gesner with the mercantile elite that ran places like Saint John. He opposed timber merchants as much as he did the General Mining Association; both restricted growth. Gesner advocated change of a steady and stable variety, although he knew very well that industry, especially coal mining, could promote such economic unrest as workers’ strikes. He avoided making the connection between industrial and political protests. His was a thoroughly Whiggish vision of an orderly, yet prosperous and expanding society. Democratic urges were largely alien to his reforms for New Brunswick and Nova Scotia. To Gesner’s mind, democracy should remain in Upper and Lower Canada or in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is therefore difficult to position Gesner’s science on one side or the other of a dichotomy, invoked by some historians, between a commercial elite and a manufacturing-labor alliance in British America. Gesner’s geology was undoubtedly more suitable to gentlemanly landowners and enterprising manufacturers than it was to miners and mechanics. But it was equally clear that "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("industry allied with science could promote stability "), _c('em', [_vm._v("and")]), _vm._v(" instability; and both could serve conservative and radical ends."), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n149"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n149a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Behind Gesner’s economic vision lay a political one. He wanted Nova Scotia and New Brunswick to prosper. Instead of exporting coal, Nova Scotia and New Brunswick should use it to smelt their own iron ore. “[A]mong the subjects of our most gracious Queen, none are more loyal,” Gesner declared, “[but] it would be a silly patriotism for them to sacrifice the natural advantages they possess to the benefit of England.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "ch01n150"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#ch01n150a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" He stopped short of connecting economic with political independence. Gesner firmly believed that a domestic industry would strengthen the colonies "), _c('em', [_vm._v("and")]), _vm._v(" Britain. He also had no doubts about the advantages the United States and Canada held by virtue of their western expanse. New Brunswick and Nova Scotia did not have vast lands to exploit. That was precisely why they must remain part of the British Empire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A final point with respect to Gesner’s geology draws attention to the land. When Gesner looked at it, he saw more than mountains, rivers, trees, soils, or Native Americans. He peered beneath—“open the earth beyond the depth of the soil.” He wanted others to find the riches that lay under foot. Prosperity meant mining, not just in the practical sense of opening coal pits, but in the metaphorical sense of digging deep to find a foundation on which to base it. If geologists and capitalists failed to do that, the consequences were dire. To someone like Gesner, the connection between civilization and science was direct, and it was built on the bedrock of geology.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f7044d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 93
// module chunks = 0